export const clientBase = (endpoint, method, { body, customConfig } = {}) => {
  const token = window.localStorage.getItem("a_t");
  const headers = { "content-type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const config = {
    method,
    ...customConfig,
    headers: {
      ...headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  return window
    .fetch(`${process.env.VUE_APP_URL}/api/${endpoint}`, config)
    .then(async (response) => {
      if (response.ok) return await response.json();
    });
};
